import {Component, EventEmitter, Inject, Input, Output} from 'ng-metadata/core';
//your imports go here
import {SmoothScrollUtil} from '../../../../nddUtils/smoothScrollUtil.service';
import {STATE_NAMES} from '../../../../primoExplore/primoExploreStates.module';
import {
    getAttributesMap,
    getResultsBulkSize,
    getVENumberOfResultsPerPageSeries
} from '../../../../appConfig/appConfigForward';
import {ChangeLangService} from '../../../../infra/lang/changeLang.service';
import {MediaQueries} from '../../../../infra/mediaQueries.service';
import {isBrowserIE} from '../../../../infra/browserSniffer';
import {isBrowserSafari} from '../../../../infra/browserSniffer';
import {PageNavMenuService} from './pageNavMenu.service';
import {beacon, PrimolyticsService} from "../../../../analytics/primolytics.service";
import {SearchBarService} from "../../../searchBar/searchBar.service";
import {FacetService} from "../../../facet/facet.service";
import {RenewResponse} from "../../../../account/loans/loans.service";
import {StorageUtil} from "../../../../infra/storageUtil.service";
import {JwtUtilService} from "../../../../security/jwtUtil.service";
import {SearchService} from "../../../search.service";
import {ResultUtil} from "../../../../nddUtils/resultUtil.service";
import {SharedSessionStorage} from "../../../../infra/sharedSessionStorage.service";
import {ConfigurationUtil} from "../../../../nddUtils/configurationUtil.service";
import {AnalyticsUtils} from "../../../../nddUtils/analyticsUtils.service";


const clone = require('lodash/clone');
const range = require('lodash/range');
const tail = require('lodash/tail');
const NUM_OF_PAGE_LINKS = 5;
const PAGES_TO_SHOW_50_BULK_WITHOUT_PAGE_BEFORE_OR_AFTER = 2;
const PAGES_TO_SHOW_50_BULK = 1;

@Component({
    selector: 'prm-page-nav-menu',
    templateUrl: 'components/search/searchResult/searchResultList/pageNavMenu/page-nav.html',
})


export class PrmPageNavMenu {
    @Input() currentPage: number;
    @Input() numOfResults: number;
    @Input() maxDisplayResults: number;
    @Input() numOfLoadedPages: number;
    @Input() showComponents: {};
    @Input() mode: string;
    @Input() facetToLeft: boolean;
    @Input() pageNumPicker: boolean;
    @Input() uiType: string;
    @Input() hasMoreResults: boolean;
    //those fields are functions(predicats)  , deteminate if  next/prev buttons should display..
    @Input() showNextButtonPredicate = () => {
        return false;
    };
    @Input() showPrevButtonPredicate = () => {
        return false;
    };

    @Output() loadNextResultsEvent = new EventEmitter<void>();
    @Output() loadPrevResultsEvent = new EventEmitter<void>();
    @Output() pickPageBulkSize = new EventEmitter<void>();
    @Output() pageBulkSize = new EventEmitter<void>();
    private pageNumUiHtml: Object;
    private isOpen: boolean = false;
    private selectedMode = 'md-fling';
    private expandDirection = 'right';
    private availablePageElements: Array<Element>;
    private SEARCH_STATE = STATE_NAMES.SEARCH;
    private closeTimeout: ng.IPromise<void>;
    private isClickEvent: boolean;


    private loadMoreResultText: string;
    private goToNextPageText: string;

    constructor(private smoothScrollUtil: SmoothScrollUtil,
                @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('$scope') private $scope: ng.IScope,
                @Inject('$element') private $element,
                @Inject('$state') private $state: ng.ui.IStateService,
                private changeLangService: ChangeLangService,
                private mediaQueries: MediaQueries,
                private pageNavMenuService: PageNavMenuService,
                private searchBarService: SearchBarService,
                private facetService: FacetService,
                private storageUtil: StorageUtil,
                private jwtUtilService: JwtUtilService,
                private searchService: SearchService,
                private primolyticsService: PrimolyticsService,
                private resultUtil: ResultUtil,
                private sharedSessionStorage: SharedSessionStorage,
                private configurationUtil: ConfigurationUtil,
                private analyticsUtils: AnalyticsUtils,
    ) {
        $translate(['nui.brief.results.loadMore', 'link.title.results.next']).then((translations) => {
            this.loadMoreResultText = translations['nui.brief.results.loadMore'];
            this.goToNextPageText = translations['link.title.results.next'];
            this.pageNavMenuService.initPageList();
        });

        this.pageNumUiHtml = {
            widget: 'components/search/searchResult/searchResultList/pageNavMenu/page-nav-menu.html',
            picker: 'components/search/searchResult/searchResultList/pageNavMenu/page-nav-picker.html'
        };
    }

    ngOnInit() {
        this.pageNavMenuService.numOfLoadedPagesVal = this.numOfLoadedPages;
        this.pageNavMenuService.numOfResultsVal = this.numOfResults;
        this.pageNavMenuService.maxDisplayResultsVal = this.maxDisplayResults;
        this.pageNavMenuService.currentPageVal = this.currentPage;
        this.pageNavMenuService.hasMoreResults = this.hasMoreResults;
        if (this.resultUtil && this.resultUtil.updatedBulkSize) {
            this.PAGE_SIZE = this.resultUtil.updatedBulkSize;
        } else {
            this.PAGE_SIZE = getResultsBulkSize(this.$state.current.name);
        }
        this.$scope.$watch(() => this.isOpen, (newVal, oldVal) => {
            this.unfocusActionButtons();
        });
    }

    public getPageNavHtml() {
        if (!this.uiType || !this.pageNumUiHtml[this.uiType]) {
            return this.pageNumUiHtml['widget']; //default
        }
        return this.pageNumUiHtml[this.uiType];
    }

    public numberOfResultsPerPageSeries(): number[] {
        if (this.configurationUtil.isSuprima()) {
            return getVENumberOfResultsPerPageSeries();
        }
        return [10, 25, 50];
    }

    get startPage(): number {
        return this.pageNavMenuService.startPage;
    }

    set startPage(startPage: number) {
        this.pageNavMenuService.startPage = startPage;
    }

    get PAGE_SIZE(): number {
        return this.pageNavMenuService.PAGE_SIZE;
    }

    set PAGE_SIZE(PAGE_SIZE: number) {
        this.pageNavMenuService.PAGE_SIZE = PAGE_SIZE;
    }

    //this function places tabindex=-1 on all fab-action buttons so that they aren't focused when md-fab-speed-dial is closed
    private unfocusActionButtons() {
        if (!this.isOpen && this.$element) {
            let actionButtons: [Element] = this.$element[0].querySelectorAll('md-fab-actions a');
            for (let button of actionButtons) {
                button.setAttribute('tabindex', '-1');
            }
        }
    }

    private getPageList() {
        if (this.facetToLeft && this.uiType == "widget") {
            return this.pageNavMenuService.availablePages.slice().reverse();
        }
        return this.pageNavMenuService.availablePages;
    }

    private getNextPage(e) {
        e.preventDefault();
        let lastLoadedPage = this.startPage + this.numOfLoadedPages - 1;
        let nextPageValue = this.currentPage + 1;
        if (this.currentPage < lastLoadedPage) {
            if (document.querySelector("#searchResultPage" + (this.currentPage + 1))) {
                this.jumpToPage(this.currentPage + 1, e);
            } else {
                this.loadNextResultsEvent.emit(null);
            }
        } else {
            this.pageNavMenuService.currentPageNumVal = nextPageValue;
            this.pageNavMenuService.getResultNumberRange();
            this.pageNavMenuService.updateRangeTitle();
            this.loadNextResultsEvent.emit(null);
        }
    }

    private jumpToPage(pageNum, e) {
        this.pageNavMenuService.needToUpdatePivInSafari = false;
        if (this.mode === 'browse') {
            e.preventDefault();
            return;
        }
        if (document.querySelector("#searchResultPage" + pageNum)) {
            e.preventDefault();
            this.smoothScrollUtil.scrollTo('searchResultPage' + pageNum, null, null);
        }
    }

    private updatePivInSafari() {
        this.pageNavMenuService.needToUpdatePivInSafari = isBrowserSafari() ? true : false;
    }

    private getPageLinkParams(pageNum: number) {
        let pageLinkParams = clone(this.$stateParams);
        pageLinkParams.offset = (pageNum - 1) * this.PAGE_SIZE;
        pageLinkParams.came_from = "pagination_" + this.currentPage + "_" + pageNum; // adding "from" and "to" pages, for beacon next\prev
        return pageLinkParams;
    }

    private onClickSpeedDial() {
        this.isClickEvent = true;
        // cancel timeouts so they don't fire after the speed dial is opened or closed by a click
        this.$timeout.cancel(this.closeTimeout);
    }

    private onTriggerButtonFocus(e) {
        this.isOpen = true;
        //this.$timeout.cancel(this.closeTimeout);
        //        if (!this.isClickEvent && !this.isOpen){
        //            this.isOpen= true;
        //            //e.target.click()
        //        }
        //        this.isClickEvent= false;
    }

    private onActionButtonFocus() {
        this.$timeout.cancel(this.closeTimeout);
    }

    private onBlur() {
        this.closeTimeout = this.$timeout(() => {
            this.isOpen = false
        }, 100);
    }


    private isLastLoadedPage(pageNum: number) {
        return pageNum === this.startPage + this.numOfLoadedPages - 1;
    }

    private isFirstLoadedPage(pageNum: number) {
        return pageNum === this.startPage;
    }

    private getNextPageButtonText() {
        if (this.isLastLoadedPage(this.currentPage)) {
            return this.loadMoreResultText;
        }
        return this.goToNextPageText;
    }


    public getPageWidgetDirection() {
        let directionStyle = window.getComputedStyle(this.$element[0].children[0]).direction;
        let dir = this.$element.attr('dir');
        if (this.changeLangService.direction === 'rtl' || dir === 'rtl' || directionStyle === 'rtl') {
            return 'left';
        }
        if (this.facetsToTheLeft) {
            return 'left';
        }
        return 'right';
    }

    get facetsToTheLeft() {
        let viewConfig = getAttributesMap();
        return viewConfig['selectedFacetLocation'] === 'left';
    }

    public isRtlMode() {
        return this.changeLangService.direction === 'rtl';
    }

    public getTooltipDirection(isPrev) {
        if (this.isRtlMode()) {
            return isPrev ? 'right' : 'left';
        }
        return isPrev ? 'left' : 'right';
    }

    public throwPrevResultsEvent() {
        this.loadPrevResultsEvent.emit(null);
    }

    get maxPage() {
        return this.pageNavMenuService.maxPage;
    }

    get maxDisplayPage() {
        return this.pageNavMenuService.maxDisplayPage;
    }

    get stateName() {
        return this.$state.current.name;
    }

    public selectedOrNotAriaPages(numberOfPage) {
        if (numberOfPage == this.currentPage) {
            return this.$translate.instant('nui.aria.currentPage', {page: this.currentPage});
        }

        return this.$translate.instant('nui.aria.paging.gotopage', {number: numberOfPage});
    }

    public selectedOrNotAriaResults(numberOfResults) {
        return this.$translate.instant('nui.aria.paging.numberOfResults', {number: numberOfResults});
    }

    private createBulkSizeEvent() {
        let eventData = {
            bulkSize: this.PAGE_SIZE,
        }
        return eventData;
    }

    @beacon({'p': 'brief', 'op': 'numOfResults'})
    public onClickPageBulkSize(size) {
        if (this.PAGE_SIZE != size) {
            this.pageNavMenuService.currentPageNumVal = 1;
            this.PAGE_SIZE = size;
            this.pageNavMenuService.getResultNumberRange();
            this.pageNavMenuService.saveNumOfPageToLocalForage(size);
            let isSignedIn = this.jwtUtilService.isSignedIn();
            isSignedIn ? this.pageNavMenuService.updateBulkSizePerPageInDB(size) : true;
            let eventData = this.createBulkSizeEvent();
            this.pageBulkSize.emit(eventData);
            this.pageNavMenuService.updateRangeTitle();
        }
    }

    public showNextPageButton() {
        if (this.showNextButtonPredicate()) {
            return true;
        }

        if (!this.currentPage) {
            return false;
        }

        if (this.isMaxDisplayResultsExceeded()) {
            return false;
        }

        if (this.hasMoreResults) {
            return true;
        }

        return (this.currentPage != this.maxPage);

    }

    public isMaxDisplayResultsExceeded() {
        return this.maxDisplayPage && this.currentPage >= this.maxDisplayPage;
    }

    public showPageNavPicker() {
        return (this.numOfResults > this.PAGE_SIZE || this.hasMoreResults);
    }

    private sendAnalytics(pageNumber) {
        let payload = this.getAnalyticsPayload( pageNumber);
        this.analyticsUtils.trackUsage(this.analyticsUtils.eventsNames.PAGINATION, payload);
    }

    private getAnalyticsPayload(pageNumber) {
        return {
            'Pagination Type': 'Page',
            'Search Term': this.primolyticsService.getSearchTerm(),
            'Page Number': pageNumber
        }
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/searchResultList/pageNavMenu/pageNavMenu.directive.ts